package com.hyperether.goodjob.repository.remote.model

import com.hyperether.goodjob.models.User
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ConfirmationResponse(
    @SerialName("data") val data: User,
    @SerialName("token") val token: String?,
    @SerialName("refreshToken") val refreshToken: String?
)
